export default __webpack_public_path__ + "static/media/avatar_147.12051e90.png";